import React from 'react';
import ContentLoader from 'react-content-loader';
import classNames from 'classnames';
import { COUNTRY } from '@makro-shopping/product-card';
import khlogo from '../../../assets/images/khLogoMini.svg';
import mlogo from '../../../assets/images/mlogo.svg';
import theme from '../../../config/theme/defaultTheme.config';
import { ProductCardVariant } from '../../../utils/constants';
import { LeoCardSkeletonContainer, SkeletonContentContainer, SkeletonRectLeo, SkeletonImageContainer } from '../style';

interface SkeletonCardProps {
  productVariant?: ProductCardVariant;
  verticalList?: boolean;
  countryCode?: string
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  productVariant = ProductCardVariant.NORMAL,
  verticalList = false,
  countryCode
}) => {
  const isCompact = productVariant === ProductCardVariant.COMPACT;
  const isCompactMini = productVariant === ProductCardVariant.COMPACT_MINI;
  const isKH = countryCode === COUNTRY.CAMBODIA;

  return (
    <LeoCardSkeletonContainer
      className={classNames({
        compact: isCompact,
        compact_mini: isCompactMini,
        vertical_list: verticalList,
      })}
    >
      <SkeletonImageContainer
        className={classNames({
          compact: isCompact,
          compact_mini: isCompactMini,
        })}
      >
        <img src={isKH? khlogo: mlogo} {...(!isKH && { height: 100, width: 100 })} alt={isKH? 'KH logo': 'M logo'} />
      </SkeletonImageContainer>
      <SkeletonContentContainer>
        <ContentLoader
          speed={2}
          width={'100%'}
          height={'100%'}
          viewBox={isCompact ? '0 0 144 120' : '0 0 200 320'}
          backgroundColor={theme.palette.grey[100]}
          foregroundColor={theme.palette.grey[200]}
        >
          <SkeletonRectLeo
            className={classNames({
              first: true,
              compact: isCompact,
              compact_mini: isCompactMini,
            })}
          />
          <SkeletonRectLeo
            className={classNames({
              second: true,
              compact: isCompact,
              compact_mini: isCompactMini,
            })}
          />
          <SkeletonRectLeo
            className={classNames({
              third: true,
              compact: isCompact,
              compact_mini: isCompactMini,
            })}
          />
          <SkeletonRectLeo
            className={classNames({
              fourth: true,
              compact: isCompact,
              compact_mini: isCompactMini,
            })}
          />
        </ContentLoader>
      </SkeletonContentContainer>
    </LeoCardSkeletonContainer>
  );
};
